module.exports = __webpack_public_path__ + "static/img/recharge.57ff2e79.svg";